import React, { useEffect, useState } from "react";
import * as Icons from "lucide-react";
import { X } from "lucide-react";
import { useLang } from "../contexts/LanguageContext";
import { api } from "../lib/api";
import Reveal from "../components/Reveal";
import ServiceCard from "../components/ServiceCard";

const Services = () => {
  const { lang, t } = useLang();
  const [services, setServices] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get("/services").then(({ data }) => setServices(data)).catch(() => {});
  }, []);

  useEffect(() => {
    document.body.style.overflow = active ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [active]);

  const ActiveIcon = active ? (Icons[active.icon] || Icons.Sparkles) : null;

  return (
    <div data-testid="services-page">
      <section className="section-pad" style={{ paddingTop: "clamp(160px, 18vw, 220px)" }}>
        <div className="font-mono line-deco" style={{ fontSize: "0.75rem", letterSpacing: "0.2em", color: "var(--gold)", textTransform: "uppercase", marginBottom: 32 }}>
          {t.services.label}
        </div>
        <h1 className="font-display" style={{ fontSize: "clamp(3rem, 8vw, 7rem)", fontWeight: 300, lineHeight: 1, color: "var(--warm-off-white)", letterSpacing: "-0.02em" }}>
          {t.services.title}
        </h1>
        <p className="font-body" style={{ color: "rgba(248,244,240,0.65)", lineHeight: 1.7, marginTop: 24, fontSize: "1.1rem", maxWidth: 640 }}>
          {t.services.intro}
        </p>
      </section>

      <section className="section-pad" style={{ paddingTop: 0 }}>
        <div className="grid" style={{ gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))", gap: 24 }}>
          {services.map((s, i) => (
            <Reveal key={s.id} delay={(i % 3) * 80}>
              <ServiceCard service={s} index={i} lang={lang} onClick={() => setActive(s)} />
            </Reveal>
          ))}
        </div>
      </section>

      {active && (
        <div
          data-testid="service-modal"
          onClick={() => setActive(null)}
          style={{
            position: "fixed", inset: 0, zIndex: 200,
            background: "rgba(10,10,10,0.92)", backdropFilter: "blur(12px)",
            display: "flex", alignItems: "center", justifyContent: "center",
            padding: 24,
          }}
        >
          <div onClick={(e) => e.stopPropagation()} style={{ background: "var(--rich-black-light)", border: "1px solid rgba(201,151,58,0.35)", maxWidth: 720, width: "100%", padding: "48px clamp(24px, 4vw, 56px)", maxHeight: "85vh", overflowY: "auto", position: "relative" }} className="corner-deco">
            <button data-testid="service-modal-close" onClick={() => setActive(null)} style={{ position: "absolute", top: 16, right: 16, background: "transparent", border: "none", color: "var(--warm-off-white)", padding: 8 }}>
              <X size={22} />
            </button>
            <div style={{ width: 64, height: 64, display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid rgba(201,151,58,0.4)", color: "var(--gold)", marginBottom: 32 }}>
              {ActiveIcon && <ActiveIcon size={28} />}
            </div>
            <h2 className="font-display" style={{ fontSize: "clamp(2rem, 4vw, 3.25rem)", fontWeight: 300, color: "var(--warm-off-white)", lineHeight: 1.1, marginBottom: 24 }}>
              {lang === "tr" ? active.title_tr : active.title_en}
            </h2>
            <p className="font-body" style={{ color: "rgba(248,244,240,0.78)", lineHeight: 1.8, fontSize: "1.05rem" }}>
              {lang === "tr" ? active.description_tr : active.description_en}
            </p>
            <div style={{ marginTop: 32, padding: 24, background: "rgba(139,32,53,0.15)", border: "1px solid rgba(139,32,53,0.35)" }}>
              <p className="font-mono" style={{ fontSize: "0.7rem", letterSpacing: "0.2em", color: "var(--gold)", textTransform: "uppercase", marginBottom: 8 }}>{t.contact.response}</p>
              <p style={{ color: "rgba(248,244,240,0.85)" }}>{lang === "tr" ? "Bu hizmet için detaylı teklif almak ister misiniz? İletişim formunu doldurun." : "Want a detailed quote for this service? Fill out the contact form."}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Services;
